import React from 'react';
import { SearchBar } from '@fiverr-private/search_bar';
import { Container } from '@fiverr-private/layout_components';
import { abTests, localeSettings, rollouts, user } from '../../../PropTypes';

interface SearchProps {
    theme?: 'dark' | 'light';
    fullWidth?: boolean;
    show?: boolean;
    showAlways?: boolean;
    showOnMobile?: boolean;
}

export const Search = (
    { theme = 'dark', fullWidth, show, showAlways, showOnMobile }: SearchProps,
    { locale, abTests, user = { id: undefined }, currency = {}, rollouts = {} }
) => (
    <Container
        width={fullWidth ? '100%' : 'auto'}
        transition="opacity 250ms ease"
        visibility={
            showAlways
                ? 'visible'
                : { default: showOnMobile && show ? 'visible' : 'hidden', md: show ? 'visible' : 'hidden' }
        }
        opacity={showAlways ? '1' : show ? '1' : '0'} // eslint-disable-line no-nested-ternary
    >
        <SearchBar
            source="top-bar"
            locale={locale}
            userId={user.id}
            abTests={abTests}
            currency={currency}
            rollouts={rollouts}
            theme={theme}
            dimBackgroundEnabled
        />
    </Container>
);

// todo: replace contextTypes with context usages
Search.contextTypes = {
    locale: localeSettings.locale,
    abTests,
    user,
    currency: localeSettings.currency,
    rollouts,
};
